import screensGoConfigFlow from './Screens/ServiceScreens';
import stepsGoConfigFlow from './Steps/ServiceSteps';

export default function extractServiceFlowJSON(configurations, service) {
  return {
    screens: screensGoConfigFlow(configurations, service),
    steps: stepsGoConfigFlow(configurations, service),
  };
}
